export const REFERRAL_STORAGE_KEY = "tmua-referral-slug";

export type ReferralCodeType = "member" | "creator";
export const REFERRAL_CODE_TYPE_MEMBER: ReferralCodeType = "member";
export const REFERRAL_CODE_TYPE_CREATOR: ReferralCodeType = "creator";

export const normalizeReferralSlug = (slug: string) => slug.trim().toLowerCase();

export const isCreatorCode = (codeType: string | null | undefined): boolean =>
  typeof codeType === "string" && codeType.toLowerCase() === REFERRAL_CODE_TYPE_CREATOR;

export const buildReferralUrl = (slug: string) => {
  const origin =
    typeof window !== "undefined"
      ? window.location.origin
      : process.env.NEXT_PUBLIC_APP_URL ?? "https://tmua.fyi";
  const cleaned = normalizeReferralSlug(slug);
  return `${origin.replace(/\/$/, "")}/refer/${cleaned}`;
};
